'use client';

import type { LogMetadata } from '@knapsack/logger';
import { datadogLogs as ddLogs } from '@datadog/browser-logs'; // https://docs.datadoghq.com/logs/log_collection/javascript/

export const log = {
  info: (message: string, metadata?: LogMetadata) => {
    console.log(message, metadata);
    ddLogs.logger.info(message, metadata, metadata?.error);
  },
  warn: (message: string, metadata?: LogMetadata) => {
    console.warn(message, metadata);
    ddLogs.logger.warn(message, metadata, metadata?.error);
  },
  error: (message: string, metadata?: LogMetadata) => {
    console.error(message, metadata);
    ddLogs.logger.error(message, metadata, metadata?.error);
  },
};
